export const basicFields = `
  mailboxId
  agentIds
`
